import { Link } from 'react-router-dom';

import type { RegionNode } from '../../../../api/regions';
import { SectionCard } from '../../regional/BucketStates';

interface Props {
  subs: RegionNode[];
  color: string;
}

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '8px 10px',
  borderRadius: 8,
  textDecoration: 'none',
  color: 'inherit',
} as const;

/** The selected region's direct subregions, each linking to its own detail page. */
export function RegionSubregionList({ subs, color }: Props) {
  return (
    <SectionCard title={`Subregions (${subs.length})`}>
      {subs.length === 0 ? (
        <div style={{ padding: '6px 4px', fontSize: 12.5, color: 'var(--nb-subtle)' }}>
          No subregions — this region is composed directly from geographies.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {subs.map((s) => (
            <Link key={s.id} to={`/admin/regions/${s.id}`} style={rowStyle}>
              <span
                style={{ width: 8, height: 8, borderRadius: 999, background: color, flexShrink: 0 }}
              />
              <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: 'var(--nb-ink)' }}>
                {s.name}
              </span>
              <span
                className="nb-mono"
                style={{ fontSize: 11, color: 'var(--nb-subtle)', width: 70, textAlign: 'right' }}
              >
                {s.code}
              </span>
              <span
                className="nb-tabular nb-mono"
                style={{ fontSize: 12, width: 78, textAlign: 'right' }}
              >
                {s.venueCount} venues
              </span>
            </Link>
          ))}
        </div>
      )}
    </SectionCard>
  );
}
